import langs from "@/constants/langs";
import areaCodes from "@/constants/area-codes";

export default {
    lang(state) {
        return langs[state.params.language] || langs.en;
    },
    isRtl(state) {
        return state.params.language === "ar";
    },
    areaCodes() {
        //return areaCodes[state.params.language] || areaCodes.en;
        return areaCodes;
    },
    settedSecurities(state) {
        return state.securities.filter(v => v.setted);
    },
    securityObj(state) {
        let tmp = {};
        state.securities.forEach(item => {
            tmp[item.type] = item;
        });
        return tmp;
    }
};
